import { render, staticRenderFns } from "./MemberContent.vue?vue&type=template&id=6c523990&scoped=true"
import script from "./MemberContent.vue?vue&type=script&lang=js"
export * from "./MemberContent.vue?vue&type=script&lang=js"
import style0 from "./MemberContent.vue?vue&type=style&index=0&id=6c523990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c523990",
  null
  
)

export default component.exports